import useTranslate from 'app/i18n/useTranslate';

const useTranslation = () => {
    const t = useTranslate('serviceIntervalsModalFooter');

    return {
        SAVE: t('save')
    };
};

export default useTranslation;
